import React from "react";
import PropTypes from "prop-types";
import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";
import { crunchClasses } from "@cayuse/shared-react.utils.helpers";
import CovertButton from "@cayuse/shared-react.components.covert-button";

import styles from "./styles.css";


const TextButton = ({ appearAsLink, children, className: incomingClassName, ...rest }) => {
	const classNames = crunchClasses({
		[styles.textButton]: true,
		[styles.link]: appearAsLink,
		[incomingClassName]: isNonEmptyString(incomingClassName)
	});

	return (
		<CovertButton className={classNames} {...rest}>
			{ children }
		</CovertButton>
	);
};

TextButton.propTypes = {
	appearAsLink: PropTypes.bool,
	className: PropTypes.string,
	children: PropTypes.node
};

export default TextButton;